import React from "react";

// styles
import './chartTooltip.scss';

interface ChartTooltipProps {
    text: string;
    show: boolean;
}

const ChartTooltip = (props: ChartTooltipProps) => {

    return <div className={`charttooltip ${props.show ? "show" : ""}`}>{props.text}</div>;
}

export default ChartTooltip;